module.exports = __webpack_public_path__ + "2667e88f9f2be70fafa3bcc2d829f0bb.jpg";